import { Box } from '@mui/material';
import { HAIRLINE } from '../colors';
import { TabDefinition, TabId } from '../../../../types/customers';

interface Props {
  tabs: readonly TabDefinition[];
  activeTab: TabId;
  onChange: (tab: TabId) => void;
}

function ProfileTabBar({ tabs, activeTab, onChange }: Props) {
  return (
    <Box
      role="tablist"
      sx={{
        display: 'flex',
        gap: { xs: '24px', sm: '36px' },
        overflowX: 'auto',
        overflowY: 'hidden',
        // Inset so the active tab's border paints over it without a negative margin.
        boxShadow: `inset 0 -1px 0 ${HAIRLINE}`,
        marginBottom: '36px',
      }}>
      {tabs.map(tab => {
        const isActive = tab.id === activeTab;
        return (
          <Box
            key={tab.id}
            component="button"
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            sx={{
              flexShrink: 0,
              background: 'none',
              border: 'none',
              padding: '0 0 14px',
              cursor: 'pointer',
              fontFamily: 'inherit',
              typography: isActive ? 'h4' : 'subtitle1',
              color: isActive ? 'text.primary' : 'text.tertiary',
              borderBottom: '2px solid',
              borderBottomColor: isActive ? 'primary.main' : 'transparent',
            }}>
            {tab.label}
          </Box>
        );
      })}
    </Box>
  );
}

export default ProfileTabBar;
